import { createSelector } from 'reselect';

export const multipleLineIemPricingSelector = createSelector(
  state => state.multipleLineItem,
  multipleLineItem => multipleLineItem.updatedMultipleLineItem,
  updatedMultipleLineItem => updatedMultipleLineItem,

);

export const previousmultipleLineIemSelector = createSelector(
  state => state.multipleLineItem,
  multipleLineItem => multipleLineItem.previousSelections,
  previousSelections => previousSelections,

);

export const currentSelectedItemSelector = createSelector(
  state => state.multipleLineItem,
  item => item.currentSelectedItem,
  currentSelectedItem => currentSelectedItem,
);

export const summaryLineItemsSelector = createSelector(
  state => state.multipleLineItem,
  item => item.currentBundleSumarry,
  currentBundleSumarry => currentBundleSumarry,
);
